import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import FinanceGroupsApi from '@/services/apiServiceModules/financeGroupsApi.js'

const financeGroupsApi = new FinanceGroupsApi()

export default class FinanceGroupsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FINANCE_GROUPS, financeGroupsApi, {
			useCache: true
		})
	}
}
